<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisStaticMap from 'dashboard/components-next/LaisStaticMap.vue';

const props = defineProps({
  visit: { type: Object, default: () => ({}) },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['finish']);

const property = computed(() => props.visit.imovel || {});
const clientName = computed(
  () => props.visit.contact?.name || props.visit.clientName || 'Cliente'
);
const propertyAddress = computed(
  () =>
    property.value.endereco ||
    property.value.address ||
    property.value.titulo ||
    props.visit.address ||
    'Endereço não informado'
);
const scheduledAtLabel = computed(() => {
  const value = props.visit.scheduledAt || props.visit.scheduled_at;
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
});
const imageSrc = computed(
  () =>
    property.value.coverUrl ||
    property.value.cover_url ||
    property.value.thumbnailUrl ||
    property.value.thumbnail_url ||
    ''
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <article
    class="overflow-hidden rounded-lais border border-amber-200 bg-white shadow-lais-card"
  >
    <div class="grid gap-3 p-4 sm:grid-cols-[96px,1fr]">
      <LaisStaticMap
        :src="imageSrc"
        :alt="property.titulo || 'Visita com finalização pendente'"
        aspect-class="aspect-[4/3]"
      />
      <div class="min-w-0">
        <div class="flex flex-wrap gap-2">
          <span
            v-if="scheduledAtLabel"
            class="rounded-full bg-lais-bg-soft px-2 py-0.5 text-[11px] font-semibold text-lais-text"
          >
            {{ scheduledAtLabel }}
          </span>
          <span
            class="rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-semibold text-amber-800"
          >
            Finalização pendente
          </span>
        </div>
        <h3 class="mt-3 truncate text-[15px] font-semibold text-lais-text">
          {{ clientName }}
        </h3>
        <p class="mt-1 text-[13px] text-lais-text-body">
          {{ propertyAddress }}
        </p>
        <button
          type="button"
          class="mt-4 rounded-lais border border-lais-primary px-3 py-2 text-[13px] font-semibold text-lais-primary transition-colors hover:bg-lais-primary hover:text-white disabled:cursor-not-allowed disabled:border-lais-border disabled:text-lais-text-muted disabled:opacity-70"
          :disabled="disabled"
          @click="emit('finish')"
        >
          Finalizar visita
        </button>
      </div>
    </div>
  </article>
</template>
